import { EvStationVolts } from '../../types';
import {
  ChargerGroup,
  ChargingSpeed,
  ConnectorTypes,
  EvConnectorResponse,
} from '../../../modules/location/aar/aar.types';

export const CHARGING_LEVEL_LIST = {
  [EvStationVolts.V480]: {
    backgroundColor: '#4481BF',
    textColor: '#1E354A',
  },
  [EvStationVolts.V240]: {
    backgroundColor: '#576E3B',
    textColor: '#8CB853',
  },
  [EvStationVolts.V120]: {
    backgroundColor: '#8DBA54',
    textColor: '#576E3B',
  },
}

export const SPEED_BOLT_COUNT: Record<ChargingSpeed, number> = {
  [ChargingSpeed.ULTRA_FAST]: 4,
  [ChargingSpeed.FAST]: 3,
  [ChargingSpeed.MEDIUM]: 2,
  [ChargingSpeed.SLOW]: 1,
}

const MODE_SPEED_MAP: Record<string, ChargingSpeed> = {
  'MODE_1': ChargingSpeed.SLOW,
  'MODE_2': ChargingSpeed.MEDIUM,
  'MODE_3': ChargingSpeed.FAST,
  'MODE_4': ChargingSpeed.ULTRA_FAST,
}

export const getChargingSpeed = (connector: EvConnectorResponse): ChargingSpeed | null=> {
  if (connector.mode && MODE_SPEED_MAP[connector.mode]) {
    return MODE_SPEED_MAP[connector.mode]
  }

  const power = connector.power ? parseFloat(connector.power) : null
  if (power === null || isNaN(power)) return null

  if (power > 100) {
    return ChargingSpeed.ULTRA_FAST
  } else if (power > 50) {
    return ChargingSpeed.FAST
  } else if (power > 7) {
    return ChargingSpeed.MEDIUM
  }
  return ChargingSpeed.SLOW
}


export const groupConnectorsByTypeAndSpeed = (
  connectors: EvConnectorResponse[]
): ChargerGroup[] => {
  const groupMap = new Map<string, ChargerGroup>()

  for (const connector of connectors) {
    const connectorType = (ConnectorTypes[connector.type_enum as keyof typeof ConnectorTypes]
      ?? ConnectorTypes.UNKNOWN) as ConnectorTypes
    const speed = getChargingSpeed(connector)
    const power = connector.power ? parseFloat(connector.power) : 0
    const key = `${connector.type_enum}_${speed}`

    const existing = groupMap.get(key)
    if (existing) {
      existing.portCount += 1
      if (power > existing.powerKw) {
        existing.powerKw = power
      }
    } else {
      groupMap.set(key, {
        connectorType,
        speed,
        powerKw: power,
        portCount: 1,
      })
    }
  }

  const speedOrder = [ChargingSpeed.ULTRA_FAST, ChargingSpeed.FAST, ChargingSpeed.MEDIUM, ChargingSpeed.SLOW]
  return Array.from(groupMap.values()).sort(
    (a, b) => speedOrder.indexOf(a.speed) - speedOrder.indexOf(b.speed)
  )
}
